import styled from "styled-components";

export const TermOfUseContainer = styled.div`
  max-width: 1240px;
  margin: 0 auto;
  padding: 48px;
`;

export const TermOfUseTitle = styled.h2`
  text-align: center;
  font-size: 32px;
  font-weight: bold;
  margin-bottom: 70px;
`;

export const TermOfUseParagraph = styled.p`
  margin-bottom: 24px;
`;
